import { Warning } from '@material-ui/icons';
import React from 'react';
import { Afternoon } from 'src/common/icons/afternoon';
import { Morning } from 'src/common/icons/morning';
import { Night } from 'src/common/icons/night';
import {
  DateText,
  Period,
  PeriodName,
  PeriodsRow,
  UrgentHeaderRow,
  UrgentOrderIndicatorContainer,
  UrgentText,
} from './styles';

interface UrgentOrderIndicatorProps {
  period: string;
  dateString: string;
}

const periods = [
  { icon: <Morning />, name: 'Manhã', id: 'morning' },
  { icon: <Afternoon />, name: 'Tarde', id: 'afternoon' },
  { icon: <Night />, name: 'Noite', id: 'night' },
];

const formatDate = (date: string) => {
  if (!date) {
    return '';
  }
  const [year, month, day] = date.split('-');
  return `${day}/${month}/${year}`;
};

export const UrgentOrderIndicator: React.FC<UrgentOrderIndicatorProps> = ({ period, dateString }) => {
  return (
    <UrgentOrderIndicatorContainer>
      <UrgentHeaderRow>
        <Warning style={{ fontSize: 40, color: 'white' }} />
        <UrgentText>Próximo/após início da janela de entrega</UrgentText>
      </UrgentHeaderRow>
      <DateText>{formatDate(dateString)}</DateText>
      <PeriodsRow>
        {periods.map(p => (
          <Period key={p.id} $active={period === p.id}>
            {p.icon}
            <PeriodName>{p.name}</PeriodName>
          </Period>
        ))}
      </PeriodsRow>
    </UrgentOrderIndicatorContainer>
  );
};
